module.exports = __webpack_public_path__ + "media/src/assets/fonts/mplus-1p-medium-2f64ca46759e0c4a7debaecfe2c21583.ttf";